/**
 * React Query Configuration
 *
 * Global React Query setup for caching, invalidation, and retry logic
 */

import { QueryClient, DefaultOptions } from "@tanstack/react-query";

/**
 * Default query options
 * Applied to all queries unless overridden per-query
 */
const defaultOptions: DefaultOptions = {
  queries: {
    // Retry failed queries with exponential backoff
    retry: (failureCount, error: any) => {
      // Don't retry on 4xx errors (client errors)
      if (error?.status >= 400 && error?.status < 500) {
        return false;
      }
      // Retry up to 3 times on server errors (5xx)
      return failureCount < 3;
    },

    // Cache data for 5 minutes by default
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000, // (formerly cacheTime) 10 minutes

    // Enable background refetch when stale
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: true,
  },

  mutations: {
    // Retry mutations on network errors, but not on 4xx
    retry: (failureCount, error: any) => {
      if (error?.status >= 400 && error?.status < 500) {
        return false;
      }
      return failureCount < 2;
    },
  },
};

export const queryClient = new QueryClient({
  defaultOptions,
});
